import React, { createContext } from "react";

export const weatherCtx = createContext({
  summerWeather: false,
  chartConfig: {
    minTemp: -16,
    maxTemp: 40,
    minAbsoluteHumidity: 0,
    maxAbsoluteHumidity: 20,
    altitude: 0,
    airflow: 10000,
    maximalHumidityInProcess: 100,
    coolerSurfaceTemperature: 10,
  },
});
export const { Provider } = weatherCtx;
